import { checkShouldUseMocks } from '@telialt/utils/src/envUtils';
import { MS_URL } from '@telialt/utils/src/microservices';

export const API = {
    URL_UNIQUE_OFFER_DOCUMENT_ID: `${MS_URL}/api/v3/offers/{segment}/contract-summary`,
    URL_UNIQUE_OFFER_SS_DOCUMENT_ID: `${MS_URL}/api/v3/offers/{segment}/contract-summary/{msisdn}`,
};

export const PLAN_SUMMARY_TOAST_ID = 'plan-summary-toast';
export const DOWNLOADABLE_FILE_NAME = 'sutarties-santrauka.pdf';

export const DOWNLOAD_CONTRACT_SUMMARY_TEST_ID = {
    DOWNLOAD_BUTTON: 'download-contract-summary-button',
    DOWNLOAD_LINK: 'download-contract-summary-link',
};

export const MUTATION_KEYS = {
    CONTRACT_SUMMARY: 'contract-summary',
};

if (checkShouldUseMocks()) {
    API.URL_UNIQUE_OFFER_DOCUMENT_ID = '/api/unique-offers/contract-summary';
    API.URL_UNIQUE_OFFER_SS_DOCUMENT_ID = '/api/unique-offers/contract-summary';
}
